module.exports = __webpack_public_path__ + "static/fonts/NanumSquareEB.9ee5085.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/NanumSquare/NanumSquareEB.ttf
// module id = riic
// module chunks = 1